export default function toGroupLabel(text) {
  if (!text || typeof text !== 'string') return text;
  return text
    .replace(/\bProjects\b/g, 'Groups')
    .replace(/\bProject\b/g, 'Group')
    .replace(/\bprojects\b/g, 'groups')
    .replace(/\bproject\b/g, 'group');
}
